import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { formatCurrency } from '../../helper/string'

const AnimatedNumber = ({ animate, children, currency }) => {
	const [haves, setHaves] = useState(children)
	const [nextHaves, setNextHaves] = useState(children)
	const moveUp = haves !== nextHaves

	const wrapperRef = useRef()

	const havesResetTimeout = useRef()
	const enableAnimateTimeout = useRef()

	const enableAnimate = () => {
		wrapperRef.current.classList.remove('no-animate')
	}

	const disableAnimate = () => {
		wrapperRef.current.classList.add('no-animate')
	}

	const formatNumber = (number) => {
		if (currency) {
			return formatCurrency(currency, number, true)
		}

		return number.toLocaleString()
	}

	useEffect(() => {
		if (moveUp) {
			havesResetTimeout.current = window.setTimeout(() => {
				if (animate) {
					disableAnimate()
				}

				setHaves(nextHaves)

				if (animate) {
					enableAnimateTimeout.current = window.setTimeout(enableAnimate, 150)
				}
			}, 200)
		}

		return () => {
			if (havesResetTimeout.current) {
				clearTimeout(havesResetTimeout.current)
			}

			if (enableAnimateTimeout.current) {
				clearTimeout(enableAnimateTimeout.current)
			}
		}
	}, [nextHaves])

	useEffect(() => {
		setNextHaves(children)
	}, [children])

	return (
		<StyledAnimatedNumber className={!animate ? 'no-animate' : undefined} ref={wrapperRef}>
			<Hidden>{formatNumber(nextHaves)}</Hidden>
			<Number moveUp={moveUp}>{formatNumber(haves)}</Number>
			<Number moveUp={moveUp}>{formatNumber(nextHaves)}</Number>
		</StyledAnimatedNumber>
	)
}

AnimatedNumber.propTypes = {
	animate: PropTypes.bool,
	children: PropTypes.any.isRequired,
	currency: PropTypes.string
}

AnimatedNumber.defaultProps = {
	animate: true,
	currency: null
}

const Number = styled.div`
	position: absolute;
	top: 0;
	left: 0;

	&:first-of-type {
		transition: 0.2s;

		${props => props.moveUp && `
			opacity: 0;
			transform: translate(0, -100%);
		`}
	}

	&:last-of-type {
		opacity: 0;
		transition: 0.2s;
		transform: translate(0, 100%);

		${props => props.moveUp && `
			opacity: 1;
			transform: translate(0, 0);
		`}
	}
`

const Hidden = styled.span`
	visibility: hidden;
`

export const StyledAnimatedNumber = styled.div`
    position: relative;
    white-space: nowrap;

    &.no-animate {
        ${Number} {
            transition: none;
        }
    }
`

export default AnimatedNumber
